import { UiTrackingDetails } from '@parship/psg-interfaces';
import { LoggerDetails, WpEvent } from '../utils/interfaces';

export class Logger {
	constructor() {
		document.addEventListener('pegLogger-logWpEvents', (event: WpEvent) =>
			this.logEvent(event.detail)
		);
	}

	private logEvent(eventData: UiTrackingDetails): void {
		if (!this.isValidPayload(eventData)) {
			return;
		}

		const data: LoggerDetails = {
			brand: this.getBrandId(),
			chiffre: null,
			category: eventData.category,
			subcategory: eventData.subcategory,
			target_id: eventData.targetId,
			action: eventData.action,
			cd1: eventData.cd1,
			cd2: eventData.cd2,
			cd3: eventData.cd3,
			cj_id: null,
			domain: window.location.hostname,
			path_name: window.location.pathname,
			user_agent: navigator.userAgent,
			display_size: this.getCurrentScreenSize(),
			client_timestamp: new Date().getTime(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			variation: eventData.variation || this.getVariation(),
			platform: 'webapp',
			referrer: document.referrer,
		};

		const loggerUrl: string = '/bd/collection?' + new Date().getTime();
		const dataAsJson: string = JSON.stringify(data);

		navigator.sendBeacon(loggerUrl, dataAsJson);
	}

	private isValidPayload(data: UiTrackingDetails): boolean {
		return data.category && data.category !== '' && data.action && data.action !== '';
	}

	private getBrandId(): string {
		const brands: object = {
			parshipmeet: '',
			eharmony: 'eh',
			elitepartner: 'ep',
			parship: 'ps',
		};

		const brandID: string = Object.keys(brands).find((brand) =>
			window.location.hostname.includes(brand)
		);

		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return brandID ? brands[brandID] : '';
	}

	private getCurrentScreenSize(): string {
		const breakpoints: { size: string; max: number }[] = [
			{ size: 'S', max: 480 },
			{ size: 'M', max: 767 },
			{ size: 'L', max: 979 },
		];
		const windowWidth: number = window.innerWidth;

		const matchingBreakpoint: { size: string; max: number } = breakpoints.find(
			(breakpoint) => windowWidth <= breakpoint.max
		);

		return matchingBreakpoint ? matchingBreakpoint.size : 'XL';
	}

	private getVariation(): string {
		const variation: RegExpExecArray = /var=([^&]+)/.exec(location.search);
		return variation ? variation[1] : 'default';
	}
}
